import React from 'react';
import styles from '../table.module.scss';
import OrgsFilterToggle from '../../components/OrgsFilterToggle/OrgsFilterToggle';

const OrgOne = ({ org, record }) => {
  if (!org?.orgName) {
    return null;
  }

  return (
    <div className={styles.additionalInfoItem}>
      <div className={styles.additionalInfoRow}>
        <span className={styles.tdItem}>{org?.orgName}</span>
        <OrgsFilterToggle
          org={org}
          record={record}
        />
      </div>
      <div
        className={styles.additionalInfoRow}
        style={{
          display: 'flex',
          alignItemns: 'start',
        }}
      >
        <span
          className={styles.tdItem}
          style={{
            opacity: 0.5,
          }}
        >
          ИНН:
        </span>{' '}
        <div
          className={styles.tdItem}
          style={{ color: '#09a2f2' }}
        >
          {org?.orgInn || 'Пусто'}
        </div>
      </div>
    </div>
  );
};

const OrgsCell = ({ record, single, rowOpened }) => {
  return (
    <>
      {single && (
        <OrgOne
          org={record.attachOrg?.[0]}
          record={record}
        />
      )}
      {!single &&
        rowOpened &&
        record.attachOrg?.length > 1 &&
        record.attachOrg?.slice(1).map((org) => (
          <OrgOne
            key={org?.orgId}
            org={org}
            record={record}
          />
        ))}
    </>
  );
};

export default OrgsCell;
